module.exports = __webpack_public_path__ + "static/img/8.ca04c68.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/zh/8.png
// module id = tVPN
// module chunks = 0